import {
  AfterViewInit, ApplicationRef, ComponentRef,
  createComponent,
  Directive,
  ElementRef, EnvironmentInjector,
  Input,
  OnInit, ViewContainerRef
} from "@angular/core";
import {TableSorterHeaderComponent} from "../../components/layout/table-sorter-header/table-sorter-header.component";
import {TableSorterDirective} from "./table-sorter.directive";

@Directive({
  selector: '[tableSorterHeader]',
  standalone: true,
})
export class TableSorterHeaderDirective implements AfterViewInit {

  @Input() tableSorterHeader: string = '';
  @Input('label') label: string | null = null;

  tableSorter: TableSorterDirective | null = null;
  tableSorterHeaderComponent!: ComponentRef<TableSorterHeaderComponent>;

  contentHtml = '';

  constructor(
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private environmentInjector: EnvironmentInjector,
    private applicationRef: ApplicationRef
  ) {
  }

  ngAfterViewInit(): void {
    this.contentHtml = this.label ? this.label : this.elementRef.nativeElement.innerHTML;

    this.tableSorterHeaderComponent = createComponent(TableSorterHeaderComponent, {
      environmentInjector: this.environmentInjector,
      hostElement: this.elementRef.nativeElement
    });
    this.applicationRef.attachView(this.tableSorterHeaderComponent.hostView);
    this.tableSorterHeaderComponent.instance.setTableSorterHeader(this);
    this.tableSorterHeaderComponent.instance.setContent(this.contentHtml);
  }

  setTableSorter(tableSorter: TableSorterDirective): void {
    this.tableSorter = tableSorter;
  }

  displaySorter(sort: string | null): void {
    this.tableSorterHeaderComponent.instance.setSort(sort);
  }

  setSort(name: string, sort: string): void {
    if (this.tableSorterHeader === name) {
      this.displaySorter(sort);
    } else {
      this.displaySorter(null);
    }
  }

  onChange(sort: string): void {
    this.tableSorter?.onChange(this.tableSorterHeader, sort);
  }
}
